import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Home from '@/pages/home/Home';
import About from '@/pages/About';
import Ecosystem from '@/pages/Ecosystem';
import Companies from '@/pages/Companies';
import Talents from '@/pages/Talents';
import Events from '@/pages/Events';
import News from '@/pages/News';
import Contact from '@/pages/Contact';
import CompanyHome from '@/pages/company/CompanyHome';
import CompanyAbout from '@/pages/company/CompanyAbout';
import CompanyServices from '@/pages/company/CompanyServices';
import CompanyPortfolio from '@/pages/company/CompanyPortfolio';
import CompanyContact from '@/pages/company/CompanyContact';

function NotFound() {
  return (
    <div className="min-h-screen bg-[#080808] flex items-center justify-center text-center px-6">
      <div>
        <p className="eyebrow mb-4">404</p>
        <h1 className="heading-display text-6xl text-[#f5f5f5] mb-6">Page Not Found</h1>
        <a href="#/" className="btn-gold-outline inline-block">Return Home</a>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        {/* ── Hub Routes ── */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/ecosystem" element={<Ecosystem />} />
        <Route path="/companies" element={<Companies />} />
        <Route path="/talents" element={<Talents />} />
        <Route path="/events" element={<Events />} />
        <Route path="/news" element={<News />} />
        <Route path="/contact" element={<Contact />} />

        {/* ── Company Sub-Routes ── */}
        <Route path="/company/:slug" element={<CompanyHome />} />
        <Route path="/company/:slug/about" element={<CompanyAbout />} />
        <Route path="/company/:slug/services" element={<CompanyServices />} />
        <Route path="/company/:slug/portfolio" element={<CompanyPortfolio />} />
        <Route path="/company/:slug/contact" element={<CompanyContact />} />

        {/* ── Fallback ── */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
